// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__3mXco","mobilePagination":"styles_mobilePagination__26_uA","searchPage":"styles_searchPage__3Qne8","page":"styles_page__1OqDX"};